import {actions} from '../reducers/OrdersPageTableReducer';
import axios from 'axios';

export const GET_ORDERS_LIST = 'orders/getList';
export const DOWNLOAD_ORDER_FILES = 'ordersFiles/downloadOrderFiles';
export const EDIT_PAID = 'orders/editPaid';
export const EDIT_TOTAL_PAYMENT = 'orders/editTotalPayment';
export const DELETE_ORDER = 'orders/deleteOrder';
export const FREEZE_ORDER = 'orders/freezeOrder';
export const UNFREEZE_ORDER = 'orders/unfreezeOrder';

export const getOrdersList = action => ({
                                          orderNumber = -1,
                                          createdFromDate = '',
                                          createdToDate = '',
                                          dueFromDate = '',
                                          dueToDate = '',
                                          customerID = -1,
                                          status = -1,
                                          shumaID = -1,
                                          requestedPageNumber = 0,
                                          sortByField = 'createdDate',
                                          sortByOrder = -1
                                        }) => dispatch => {

  const data = {
    orderNumber: parseInt(orderNumber, 10),
    createdFromDate,
    createdToDate,
    dueFromDate,
    dueToDate,
    customerID: parseInt(customerID, 10),
    status: parseInt(status, 10),
    shumaID: parseInt(shumaID, 10),
    requestedPageNumber: parseInt(requestedPageNumber, 10),
    sortByField,
    sortByOrder: parseInt(sortByOrder, 10),
  };

  return axios.post(GET_ORDERS_LIST, data)
    .then(response => {
      const {errorCode, body} = response.data;
      if (errorCode < 0) throw new Error();
      const {totalPageCount, currentPageNumber, list, totalResultCount} = body;

      dispatch(action({
        totalPageCount,
        currentPageNumber,
        orders: list,
        totalResultCount,
      }));
    })
    .catch(error => {
      error.clientMessage = 'Can\'t find data';
      dispatch(actions.catchError(error));
    });
};
export const getOrders = getOrdersList(actions.ordersFetched);
export const getNextOrders = getOrdersList(actions.ordersAppended);

export const downloadOrderFiles = async (orderID) => {
  const response = await axios.post(DOWNLOAD_ORDER_FILES, {orderID}, {responseType: 'blob'});
  return response.data;
};

export const editPaid = ({orderID, paid}) => (dispatch) => {
  const data = {
    orderID: parseInt(orderID, 10),
    paid: paid ? parseFloat(paid) : 0
  };

  return axios.post(EDIT_PAID, data)
    .then(response => {
      const {errorCode} = response.data;
      if (errorCode < 0) {
        throw new Error();
      } else {
        dispatch(actions.editPaid({orderID, paid}));
      }
    })
    .catch(error => {
      error.clientMessage = 'Can\'t send data';
    });
};

export const editTotalPayment = ({orderID, totalPayment}) => (dispatch) => {
  const data = {
    orderID: parseInt(orderID, 10),
    totalPayment: totalPayment ? parseFloat(totalPayment) : 0
  };

  return axios.post(EDIT_TOTAL_PAYMENT, data)
    .then(response => {
      const {errorCode} = response.data;
      if (errorCode < 0) {
        throw new Error();
      } else {
        dispatch(actions.editTotalPayment({orderID, totalPayment}));
      }
    })
    .catch(error => {
      error.clientMessage = 'Can\'t send data';
    });
};

export const deleteOrder = orderID => dispatch => {
  const data = {
    orderID: parseInt(orderID, 10),
  };

  return axios.post(DELETE_ORDER, data)
    .then(response => {
      const {errorCode} = response.data;
      if (errorCode === 0) {
        dispatch(actions.deleteOrder({orderID}));
      } else {
        throw new Error();
      }
    })
    .catch(error => {
      error.clientMessage = "Can't delete order";
    });
};

export const freezeOrder = orderID => dispatch => {
  const data = {
    orderID: parseInt(orderID, 10),
  };

  return axios.post(FREEZE_ORDER, data)
    .then(response => {
      const {errorCode} = response.data;
      if (errorCode === 0) {
        dispatch(actions.freezeOrder({orderID}));
      } else {
        throw new Error();
      }
    })
    .catch(error => {
      error.clientMessage = "Can't freeze order";
    });
};

export const unFreezeOrder = orderID => dispatch => {
  const data = {
    orderID: parseInt(orderID, 10),
  };

  return axios.post(UNFREEZE_ORDER, data)
    .then(response => {
      const {errorCode, body} = response.data;
      if (errorCode === 0 && body?.orderStatusID) {
        dispatch(actions.unfreezeOrder({orderID, status: body.orderStatusID}));
      } else {
        throw new Error();
      }
    })
    .catch(error => {
      error.clientMessage = "Can't unfreeze order";
    });
};